import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { abstractDark, abstractLight } from './theme';

/*
 * These two extensions reuse the built-in theme names ("light" / "dark") so they
 * OVERRIDE the app plugin's default themes rather than adding two extra options to
 * the picker. Result: exactly two themes, both skinned, and the app's default
 * selection (driven by the viewer's OS colour-scheme preference) lands on the skin
 * immediately. Installing themes as a module on the `app` plugin is the sanctioned
 * path (see @backstage/plugin-app AppThemeApi), mirroring this repo's navModule.
 */
const lightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Abstract Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={abstractLight}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const darkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Abstract Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={abstractDark}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightTheme, darkTheme],
});

export default themeModule;
